<template>
  <div class="app_box">
    <div class="card_box" v-for="item in appList" :key="item.appKeyID">
      <div class="card" @click="viewAppDetail(item)">
        <div class="app_icon_three">
          <template>
            <div class="icon_position">
              <img
                v-for="v in item.models"
                :key="v.templateType"
                :src="
                  v.templateType == 'helm'
                    ? helmIcon
                    : v.templateType == 'RAM'
                    ? ramIcon
                    : v.templateType == 'docker'
                    ? dockerIcon
                    : fileIcon
                "
                :alt="
                  v.templateType == 'helm'
                    ? 'helm'
                    : v.templateType == 'rainbond'
                    ? 'ram'
                    : v.templateType == 'docker'
                    ? 'docker'
                    : 'file'
                "
              />
            </div>
          </template>
          <template v-if="item.recommend != 0">
            <div class="icon_sift">
              <img :src="siftIcon" alt="" />
            </div>
          </template>
          <div
            class="back_div"
            :style="{
              backgroundImage: `url(${item.logo || appLogoDef})`
            }"
          ></div>
          <img class="logoIcon" :src="item.logo || appLogoDef" />
        </div>
        <!-- 分割线 -->
        <div class="app_line_three"></div>
        <!-- 名称 -->
        <div class="app_name_three">
          <div @click="viewAppDetail(item)">{{ item.name }}</div>
        </div>
        <!-- 版本 -->
        <div class="app_version_three">版本: {{ item.maxVersion }}</div>
        <!-- 描述 -->
        <div class="app_desc_three">
          <p>{{ item.desc }}</p>
        </div>
        <!-- 分割线 -->
        <div class="app_line_three"></div>
        <!-- 浏览访问量 -->
        <div class="app_data_three">
          <!-- 浏览量 -->
            <div class="visit_three" v-if="item.showCount > 0">
              <span>浏览</span>
              <span class="countSpan">{{ item.showCount }}</span>
            </div>
          <!-- 安装量 -->
            <div class="install_three" v-if="item.installCount > 0">
              <span>安装</span>
              <span class="countSpan">{{ item.installCount }}</span>
            </div>
          <!-- 评论数 -->
          <div class="install_three" v-if="item.comments > 0">
              <span>评论</span>
              <span class="countSpan">{{ item.comments }}</span>
            </div>
        </div>
        <!-- 分割线 -->
        <div class="app_line_three"></div>
        <!-- 标签 -->
        <div class="tags_box_three">
          <div
            class="tag_item_three"
            v-for="(tag, idx) in item.tags"
            :key="idx"
          >
            {{ tag }}
          </div>
        </div>
        <div class="timeUpdate">
          {{ timmer(item.updateTime) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import appInstall from '@/assets/images/app_install.svg';
import appVisit from '@/assets/images/app_visit.svg';
import helmIcon from '@/assets/images/helm.svg';
import fileIcon from '@/assets/images/file.svg';
import ramIcon from '@/assets/images/ram.svg';
import dockerIcon from '@/assets/images/docker.svg';
import siftIcon from '@/assets/images/sift.svg';
export default {
  name: 'AppCard',
  props: {
    appList: Array,
    appLoading: Boolean,
    viewAppDetail: Function,
    timmer: Function
  },
  data() {
    return {
      appInstall,
      appVisit,
      helmIcon,
      fileIcon,
      ramIcon,
      dockerIcon,
      siftIcon,
      appLogoDef: require('@/assets/images/app_icon.png')
    };
  },
  components: {}
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.countSpan{
  color: #5d5959 !important;
  font-weight: 600;
}
.app_box {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  min-height: 250px;
}
.card_box {
  width: 25%;
  padding: 6px;
  margin-bottom: 30px;
}
.card {
  width: 100%;
  height: 320px;
  border-radius: 5px;
  background: #f5f5f5;
  cursor: pointer;
  position: relative;
  border: 1px solid #c3c6ce;
  transition: 0.5s ease-out;
  overflow: visible;
  font-family: 'Segoe UI', 'Segoe UI Web (West European)', 'Segoe UI',
    -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica Neue', sans-serif;
}

.card-details {
  color: black;
  height: 100%;
  gap: 0.5em;
  display: grid;
  place-content: center;
}

.card-button {
  transform: translate(-50%, 125%);
  width: 60%;
  border-radius: 10px;
  border: none;
  background-color: #008bf8;
  color: #fff;
  font-size: 1rem;
  padding: 0.5rem 1rem;
  position: absolute;
  left: 50%;
  bottom: 0;
  opacity: 0;
  transition: 0.3s ease-out;
}

.timeUpdate {
  position: absolute;
  right: 5%;
  bottom: 2%;
  font-size: 12px;
  color: rgba(84, 88, 90, 0.7);
}

.text-body {
  color: rgb(134, 134, 134);
}

/*Text*/
.text-title {
  font-size: 1.5em;
  font-weight: bold;
}

/*Hover*/
.card:hover {
  border-color: #008bf8;
  box-shadow: 0 4px 18px 0 rgba(0, 0, 0, 0.25);
}

.card:hover .card-button {
  transform: translate(-50%, 50%);
  opacity: 1;
}

// 三行
.app_item_three,
.card:hover .app_icon_three .back_div {
  transition: 0.3s ease-in;
  filter: blur(40px);
}
.card,
.app_item_three {
  width: 100%;
  background-color: #ffffff;
  position: relative;
  border-radius: 5px;
  p {
    margin-bottom: 0px !important;
  }
  // 图标
  .app_icon_three {
    height: 80px;
    width: 100%;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    position: relative;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    .icon_position {
      width: 80px;
      height: 24px;
      display: flex;
      flex-direction: row-reverse;
      position: absolute;
      top: 4%;
      right: 1%;
      img {
        width: 16px;
        height: 16px;
        margin-right: 2px;
      }
    }
    .icon_sift {
      width: 24px;
      height: 24px;
      position: absolute;
      top: 0%;
      left: -1%;
      z-index: 2;
      img {
        width: 38px;
        height: 38px;
      }
    }

    .back_div {
      position: absolute;
      width: 100%;
      height: 80px;
      background-size: cover;
      filter: blur(150px);
      background-position: 50% 50%;
    }
    .logoIcon {
      margin: 10px 35%;
      width: 60px;
    }
  }
  // 分割线
  .app_line_three {
    height: 1px;
    background-color: #faf4f4;
  }
  // 名称
  .app_name_three {
    padding: 5px 16px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-weight: bold;
    color: #000;
    text-align: center;
    div {
      cursor: pointer;
    }
  }
  // 版本
  .app_version_three {
    width: 100%;
    height: 24px;
    color: rgba(84, 88, 90, 0.7);
    padding: 0px 16px 5px 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: center;
    margin-top: 6px;
  }
  // 描述
  .app_desc_three {
    font-size: 12px;
    padding: 0px 16px;
    margin-bottom: 5px;
    max-height: 56px;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    min-height: 56px;
    word-break: break-all;
  }
  // 浏览访问数
  .app_data_three {
    display: flex;
    padding: 5px 16px;
    text-align: center;
    justify-content: space-around;
    span {
      color: rgba(84, 88, 90, 0.7);
      font-size: 12px;
    }
    .visit_three {
      margin-right: 12px;
    }
  }
  // 标签
  .tags_box_three {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    padding: 12px 4px;
    height: 38px;
    overflow: hidden;
    .tag_item_three {
      max-width: 80px;
      color: rgba(84, 88, 90, 0.7);
      height: 22px;
      margin: 0 6px 6px 0;
      background: #f2f4f6;
      border: 1px solid #dde1e6;
      border-radius: 3px;
      padding: 0 8px;
      font-size: 12px;
      line-height: 20px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }
  .more_three {
    position: absolute;
    width: 100%;
    left: 50%;
    transform: translate(-50%, -50%);
    bottom: 10px;
    text-align: center;

    span {
      color: #456fe2;
      cursor: pointer;
    }
  }
  .app_name_three > span:hover {
    color: #456fe2;
  }
  &:hover {
    transition: 0.3s ease-in;
    box-shadow: 2px 4px 10px 0px rgba(0, 0, 0, 0.1);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AppCard/card.vue